import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class PerimeterStrictIcon extends BaseIcon {
  getChildren = () => [
    <g fill={ this.getColor() }>
      <path d="M8,4,4,5.56l1.06,5.37L8,12l2.94-1.07L12,5.56Z"/>
      <path d="M8,2.29A5.71,5.71,0,1,1,2.29,8,5.71,5.71,0,0,1,8,2.29M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0Z"/>
    </g>
  ]
  getViewBox = () => '0 0 16 16'
}


